module.exports = __webpack_public_path__ + "static/media/06_icon-burnaby.64958f5a.jpg";